import { render, staticRenderFns } from "./CreateWorkflow.vue?vue&type=template&id=581bc316&"
import script from "./CreateWorkflow.vue?vue&type=script&lang=js&"
export * from "./CreateWorkflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports